import { Route } from '@/app/router'

const ReservationOem = () => import('./index.vue')

export default new Route('/reservations-oem/:id', ReservationOem)
	.as('Dashboard:ReservationOem')
	.permissions(['VIEW_OEM_ORDER', 'OEM_ENABLED'])
